import { render } from "./EventosPage.vue?vue&type=template&id=3fe545de"
import script from "./EventosPage.vue?vue&type=script&lang=js"
export * from "./EventosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__